const STATUS_DIC = {
  active: 'Activa',
  unstarted: 'No iniciada',
  expired: 'Expirada',
  suspended: 'Suspendida',
  completed: 'Completada'
}

const TASK_TYPE_DIC = {
  images: 'Imágenes',
  inventory: 'Captura de Inventario',
  survey: 'Encuesta',
  data_update: 'Actualización de datos',
  planimetry: 'Verificación de Planimetría',
  price_capture: 'Captura de Precios Propios y/o Competencia',
  client_application: 'Levantamiento de Cliente',
  expiration_date: 'Fecha de Vencimiento',
  clients_check_in_out: 'Check In/Out por Cliente',
  users_start_end_day: 'Marcación de Inicio/Fin de Dia',
  power_sku: 'Power SKUs'
}

const TASK_TYPES = Object.freeze({
  inventory: {
    key: 'inventory',
    name: 'Captura de inventario',
    shortName: 'CAPTURA DE INVENTARIO',
    description: 'Captura de Inventario',
    downloadName: 'CapturaDeInventario'
  },
  price_capture: {
    key: 'price_capture',
    name: 'Captura de precios propios y/o competencia',
    shortName: 'CAPTURA DE PRECIOS',
    description: 'Captura de Precios Propios y/o Competencia',
    downloadName: 'CapturaDePreciosPropios_Y_O_Competencia'
  },
  clients_check_in_out: {
    key: 'clients_check_in_out',
    name: 'Check In/Out detallado por cliente',
    shortName: 'CHECK IN/OUT CLIENTE',
    description: 'Check In/Out por Cliente',
    downloadName: 'Check_In_Out_PorCliente'
  },
  survey: {
    key: 'survey',
    name: 'Encuesta',
    shortName: 'ENCUESTA',
    description: 'Encuesta',
    downloadName: 'Encuesta'
  },
  expiration_date: {
    key: 'expiration_date',
    name: 'Fecha de vencimiento',
    shortName: 'FECHA DE VENCIMIENTO',
    description: 'Fecha de Vencimiento',
    downloadName: 'FechaDeVencimiento'
  },
  client_application: {
    key: 'client_application',
    name: 'Levantamiento de cliente',
    shortName: 'LEVANTAMIENTO DE CLIENTE',
    description: 'Levantamiento de Cliente',
    downloadName: 'LevantamientoDeCliente'
  },
  users_start_end_day: {
    key: 'users_start_end_day',
    name: 'Marcación de Inicio/Fin de dia',
    shortName: 'INICIO/FIN DE DIA',
    description: 'Marcación de Inicio/Fin de Dia',
    downloadName: 'MarcaciónInicio_FinDeDia'
  },
  refund_limit: {
    key: 'refund_limit',
    name: 'Máximo de devoluciones',
    shortName: 'MÁXIMO DE DEVOLUCIONES',
    description: 'Máximo de devoluciones',
    downloadName: 'MaximoDeDevoluciones'
  },
  power_sku: {
    key: 'power_sku',
    name: 'Power SKUs',
    shortName: 'POWER SKUS',
    description: 'Power SKUs',
    downloadName: 'PowerSKUs'
  },
  planimetry: {
    key: 'planimetry',
    name: 'Verificación de planimetría',
    shortName: 'PLANIMETRÍA',
    description: 'Verificación de Planimetría',
    downloadName: 'VerificacionDePlanimetria'
  }
})

const DAY_DIC = {
  0: 'Domingo',
  1: 'Lunes',
  2: 'Martes',
  3: 'Miércoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sábado'
}

const TASK_TYPES_KEYS = Object.keys(TASK_TYPES)

const PROD_TYPE_DIC = {
  brand: 'Marca',
  individual_products: 'Producto individual',
  category: 'Categoría'
}

// Las claves coinciden con los prefijos de las opciones y product_group de la API.
const POS_REPORT_PRODUCT_GROUPS = Object.freeze(
  ['Marcas', PROD_TYPE_DIC.individual_products].map((label) => Object.freeze({ key: label, label }))
)
const DEFAULT_POS_REPORT_PRODUCT_GROUP = POS_REPORT_PRODUCT_GROUPS[0].key

export {
  STATUS_DIC,
  TASK_TYPE_DIC,
  TASK_TYPES,
  TASK_TYPES_KEYS,
  PROD_TYPE_DIC,
  DAY_DIC,
  POS_REPORT_PRODUCT_GROUPS,
  DEFAULT_POS_REPORT_PRODUCT_GROUP
}
